import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter } from '../../../adapter/Adapter.mjs';
import {
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  nullable1in0t8o94jx9t as nullable,
  presentmhd0a0ip21um as present,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  list2lpjhmv1d2k19 as list,
  obj2vqjd1bjrpmyg as obj,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Badge_ResponseAdapter_instance9mu49fvvgdlz as Badge_ResponseAdapter_instance } from './Badge_ResponseAdapter.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { AvatarType_ResponseAdapter_instance32ktucgjbbtjc as AvatarType_ResponseAdapter_instance } from './AvatarType_ResponseAdapter.mjs';
import { PinInput_InputAdapter_instance7qh971mvyfs7 as PinInput_InputAdapter_instance } from './PinInput_InputAdapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PinnedPlayerInput1hnlnl1bk4or8 as PinnedPlayerInput } from '../PinnedPlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInput_InputAdapterClass;
function PinnedPlayerInput_InputAdapter() {
  if (PinnedPlayerInput_InputAdapterClass === VOID) {
    class $ {
      e40(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      o6r(writer, customScalarAdapters, value) {
        writer.h48('id');
        get_playerIdAdapter().f40(writer, customScalarAdapters, value.e6p_1);
        writer.h48('name');
        get_StringAdapter().f40(writer, customScalarAdapters, value.f6p_1);
        writer.h48('email');
        get_StringAdapter().f40(writer, customScalarAdapters, value.g6p_1);
        var tmp = value.h6p_1;
        if (tmp instanceof Present()) {
          writer.h48('badge');
          present(nullable(Badge_ResponseAdapter_instance)).o41(writer, customScalarAdapters, value.h6p_1);
        }
        writer.h48('callSignAdjective');
        get_StringAdapter().f40(writer, customScalarAdapters, value.i6p_1);
        writer.h48('callSignNoun');
        get_StringAdapter().f40(writer, customScalarAdapters, value.j6p_1);
        var tmp_0 = value.k6p_1;
        if (tmp_0 instanceof Present()) {
          writer.h48('imageURL');
          present(get_NullableStringAdapter()).o41(writer, customScalarAdapters, value.k6p_1);
        }
        var tmp_1 = value.l6p_1;
        if (tmp_1 instanceof Present()) {
          writer.h48('avatarType');
          present(nullable(AvatarType_ResponseAdapter_instance)).o41(writer, customScalarAdapters, value.l6p_1);
        }
        writer.h48('unvalidatedEmails');
        list(get_StringAdapter()).m41(writer, customScalarAdapters, value.m6p_1);
        writer.h48('pins');
        list(obj(PinInput_InputAdapter_instance)).m41(writer, customScalarAdapters, value.n6p_1);
      }
      f40(writer, customScalarAdapters, value) {
        return this.o6r(writer, customScalarAdapters, value instanceof PinnedPlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'PinnedPlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    PinnedPlayerInput_InputAdapterClass = $;
  }
  return PinnedPlayerInput_InputAdapterClass;
}
var PinnedPlayerInput_InputAdapter_instance;
function PinnedPlayerInput_InputAdapter_getInstance() {
  return PinnedPlayerInput_InputAdapter_instance;
}
//region block: init
PinnedPlayerInput_InputAdapter_instance = new (PinnedPlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  PinnedPlayerInput_InputAdapter_instance as PinnedPlayerInput_InputAdapter_instancesqyq5n185zzu,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput_InputAdapter.mjs.map
